export class FleetTrailerUpdateModel {
  trailerFinancingStatus: string = '';
  trailerImplement: string = '';
  trailerMaterial: string = '';
  trailerType: string = '';
  trailerYear: number = 0;
  trailerAcquisitionDate: Date = new Date;
  trailerResidual: number = 0;
}
